var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogleSlides(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 52",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.222 1l13.596 13.596v33.859c0 .7-.287 1.335-.748 1.796a2.537 2.537 0 01-1.797.749h0H9.545c-.7 0-1.335-.287-1.796-.749A2.537 2.537 0 017 48.455h0V3.545c0-.7.287-1.335.749-1.796A2.537 2.537 0 019.545 1h19.677z",
    stroke: "#F4B400",
    strokeWidth: 2,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.59 23.636H17.228c-.975 0-1.772.798-1.772 1.773v15.364c0 .975.797 1.772 1.772 1.772h15.364c.975 0 1.773-.797 1.773-1.772V25.409c0-.975-.798-1.773-1.773-1.773zM32 37.227H17.818v-8.272H32v8.272z",
    fill: "#F4B912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.636 2.414l10.768 10.768h-8.222c-.703 0-1.34-.285-1.8-.745a2.538 2.538 0 01-.746-1.8h0V2.413z",
    stroke: "#F4B400",
    strokeWidth: 2,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.1,
    fill: "#FFF",
    d: "M29.636 0v.295l13.887 13.887h.295z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.273 51.705H9.545A3.556 3.556 0 016 48.159v.296A3.556 3.556 0 009.545 52h30.728a3.556 3.556 0 003.545-3.545v-.296a3.556 3.556 0 01-3.545 3.546z",
    fillOpacity: 0.2,
    fill: "#BF360C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.182 14.182a3.544 3.544 0 01-3.546-3.546v.296a3.544 3.544 0 003.546 3.545h10.636v-.295H33.182z",
    fillOpacity: 0.1,
    fill: "#BF360C"
  }))));
}

export default SvgGoogleSlides;